import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    root: {
        color: '#597DDA',
        fontSize: '1.125rem',
        fontWeight: 700
    },
    paragraphRoot: {
        marginBottom: "0px !important"
    },
}));

interface TitleAndSubtitle {
    title: string,
    style?: React.CSSProperties
}

export default function (props: TitleAndSubtitle) {
    const classes = useStyles();

    return (
        <div className={classes.root} style={props.style}>
            <p className={classes.paragraphRoot}>{props.title}</p>
        </div>
    );
}

